import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { uiActions } from '_actions/ui.actions';

class ScrollDiv extends React.Component {

    constructor() {
        super();
        this.divRef = React.createRef();
        this.state = { scrollTop: 0, changingTimeout: 0, hasChanges: false, changingNote: false };
        this.onScroll = this.onScroll.bind(this);
        this.saveScroll = this.saveScroll.bind(this);
    }

    onScroll() {
        if (this.state.changingNote) {
            this.setState({ changingNote: false });
        } else if (this.divRef.current) {
            const scrollTop = this.divRef.current.scrollTop;

            if (this.state.changingTimeout) {
                clearTimeout(this.state.changingTimeout);
            }

            this.setState({
                scrollTop: scrollTop,
                hasChanges: true,
                changingNote: false,
                changingTimeout: setTimeout(() => this.saveScroll(), 2000)
            });
        }
    }

    saveScroll() {
        if (this.state.hasChanges) {
            this.props.saveScroll({ id: this.props.divId, pos: this.state.scrollTop });
            this.setState({ hasChanges: false });
        }
    }

    componentDidMount() {
        this.divRef.current.scrollTop = this.props.scrollPos;
    }

    componentWillUnmount() {
        this.saveScroll();
        clearTimeout(this.state.changingTimeout);
    }

    getSnapshotBeforeUpdate(prevProps, prevState) {
        if (prevProps.divId !== this.props.divId && prevState.hasChanges) {
            this.props.saveScroll({ id: prevProps.divId, pos: prevState.scrollTop });
        }
        return null;
    }

    componentDidUpdate(prevProps) {
        if (this.props.divId !== prevProps.divId) {
            this.setState({ changingNote: true, scrollTop: this.props.scrollPos });
            this.divRef.current.scrollTop = this.props.scrollPos;
        }
    }

    render() {
        return (
            <div id={this.props.divId} key={this.props.divId} ref={this.divRef} onScroll={() => this.onScroll()} className={this.props.className ? this.props.className : ''}>
                {this.props.children}
            </div>
        );
    }
}


function mapDispatchToProps(dispatch) {
    return {
        saveScroll: bindActionCreators(uiActions.saveScroll, dispatch)
    };
}

function mapStateToProps(state, ownprops) {
    return {
        scrollPos: state.ui.scrollPos[ownprops.divId] ? state.ui.scrollPos[ownprops.divId].pos : 0
    };
}

const connectedScrollDiv = connect(mapStateToProps, mapDispatchToProps)(ScrollDiv);
export { connectedScrollDiv as ScrollDiv };

